import { Component, OnInit } from '@angular/core';
import { ArticleTemplate, EditEventType } from '../../_models';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { ActivatedRoute, Router } from '@angular/router'
import { ArticleTemplateService } from '../../_services'
import { EditInputComponent } from '../_shared/edit-input/edit-input.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { packageDimensionValidator, packageWeightValidator } from '../../_validators/mac-address.validator';
@Component({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    EditInputComponent,
    NgSelectModule,
    FontAwesomeModule
  ],
  selector: 'hawk-article-template-show',
  templateUrl: './article-template-show.component.html',
  styleUrls: ['./article-template-show.component.scss'],
  host: {
    class: 'app-page',
  }
})
export class ArticleTemplateShowComponent implements OnInit {
  public articleTemplateId: string | string | number
  public newArticleTemplate: boolean = false
  public submittingTemplate: boolean = false
  public articleTemplate: ArticleTemplate;
  public articleTemplateForm: FormGroup;

  public badPartHandlingOptions = [
    { name: 'Keine', id: null },
    { name: 'Reparatur: SPC', id: 'SPC' },
    { name: 'Reparatur: PartnerTECH', id: 'PartnerTECH' },
    { name: 'Reparatur: METTLER', id: 'METTLER' },
    { name: 'Entsorgung', id: 'DISPOSAL' },
  ]

  public editingProps = {
    description: false,
    product_category: false,
    vendor: false,
    part_nr: false,
    end_of_life: false,
    sn: false,
    comment1: false,
    comment2: false,
    comment3: false,
    default_owner_bentomax: false,
    bad_part_handling: false,
    info: false,
    purchase_value: false,
    selling_value: false,
    warning_threshold: false,
    minimum_stock: false,
    unidata_report: false,
    unidatahdd: false,
    unidata_reinstall: false,
    active: false,
    // Neue Felder für Paketabmessungen
    package_height: false,
    package_width: false,
    package_length: false,
    package_weight: false,
    // Neue Felder für Bestellinformationen
    order_link: false,
    order_number: false
  }

  // Column Definitions: Defines the columns to be displayed.
  constructor(
    private articleTemplateService: ArticleTemplateService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.articleTemplateId = params.get('id')
      if(Number(this.articleTemplateId) > 0) {
        this.newArticleTemplate = false;
        this.loadArticleTemplate()
      } else {
        this.newArticleTemplate = true;
        this.articleTemplateForm = new FormGroup({
          description: new FormControl(null, Validators.required),
          product_category: new FormControl(null, Validators.required),
          vendor: new FormControl(null, Validators.required),
          part_nr: new FormControl(),
          end_of_life: new FormControl(false),
          sn: new FormControl(true),
          comment1: new FormControl(''),
          comment2: new FormControl(''),
          comment3: new FormControl(''),

          default_owner_bentomax: new FormControl(false),
          bad_part_handling: new FormControl(null),
          info: new FormControl(''),
          purchase_value: new FormControl(),
          selling_value: new FormControl(),
          warning_threshold: new FormControl(),
          minimum_stock: new FormControl(),
          unidata_report: new FormControl(false),
          unidatahdd: new FormControl(false),
          unidata_reinstall: new FormControl(false),
          
          // Neue Felder für Paketabmessungen
          package_height: new FormControl(null, packageDimensionValidator()),
          package_width: new FormControl(null, packageDimensionValidator()),
          package_length: new FormControl(null, packageDimensionValidator()),
          package_weight: new FormControl(null, packageWeightValidator()),
          
          // Neue Felder für Bestellinformationen
          order_link: new FormControl(''),
          order_number: new FormControl('')
        });
      }
    });
  }

  private loadArticleTemplate() {
    this.articleTemplateService.getArticleTemplate(this.articleTemplateId).subscribe(
      {
        next: (response) => {
          this.articleTemplate = response;
        },
        error: (error) => {
          console.log('error', error);
        }
      }
    )
  }

  public onDelete() {
    if(confirm('Möchten Sie die Artikelvorlage wirklich löschen?')) {
      this.articleTemplateService.delete(this.articleTemplateId).subscribe(
        {
          next: () => {
            this.router.navigate(['/', 'artikelvorlagen', 'uebersicht']);
          },
          error: (error) => {
            alert(error?.message || 'Something wrong went');
          }
        }
      )
    }
    return false;
  }

  public updateKey(field: string, event: EditEventType) {
    this.metaUpdate(field, event)
  }

  private metaUpdate(key = null, value = null, data = {}) {
    const changeData = key === null ? data : {}
    if(key !== null)
      changeData[key] = value
    this.articleTemplateService.update(this.articleTemplateId, { article_template: changeData })
    .subscribe(
      {
        next: (response) => {
          this.articleTemplate = response;
          if(key)
            this.editingProps[key] = false;
        },
        error: (error) => {
          console.log('error', error);
        }
      }
    )
  }

  // New template

  public createArticleTemplate() {
    const params = this.articleTemplateForm.value;
    this.submittingTemplate = true;
    this.articleTemplateService.create({ article_template: params }).subscribe(
      {
        next: (response) => {
          this.submittingTemplate = false;
          this.router.navigate(['/', 'artikelvorlagen', response.id]);
        },
        error: (error) => {
          console.log('error', error);
          alert(`Please fix errors: ${error}`);
          this.submittingTemplate = false;
        }
      }
    )
  }

  public badPartLabel(badPartHandlingId: string | null): string {
    const option = this.badPartHandlingOptions.find(option => option.id === badPartHandlingId);
    return option ? option.name : this.badPartHandlingOptions[0].name;
  }

}
